import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../../context";
import { createStyles } from "@mantine/emotion";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
let source;

const useStyles = createStyles({
  footer: {
    marginTop: "16px",
    "@media print": { display: "none" },
  },
});

const Footer = (props) => {
  const { classes } = useStyles();
  const [text, setText] = useState("");
  const {
    state: { config, posId, culture },
  } = useContext(AppContext);
  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/footer.${culture}.md`,
        {
          cancelToken: source.token,
        }
      )
      .then((r) => setText(r.data))
      .catch((e) => console.error(e));
    return () => source.cancel("Footer Is Unmounting");
  }, [culture, posId]);

  return (
    <div className={`${classes.footer} footer__container`}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
    </div>
  );
};

export default Footer;
